import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import { loadStripe } from '@stripe/stripe-js';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeft, FaSpinner, FaCamera, FaUpload, FaTimes, FaImages ,FaGlasses} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { FaShoppingCart } from "react-icons/fa";
import { menHairstyles, womenHairstyles } from './HairstyleGallery';
import { extentionsHairstyles,bangsHairstylesMen, bangsHairstylesWomen, volumeHairstylesWomen } from './HairstyleGallery';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const API_URL = process.env.REACT_APP_API_URL;

const recommendations = [
  { src: "/Recomended photos/correct1.jpg", alt: "Recommended 1" },
  { src: "/Recomended photos/correct2.jpg", alt: "Recommended 2" },
  { src: "/Recomended photos/correct3.jpg", alt: "Recommended 3" },
];

const avoid = [
  { src: "/Recomended photos/avoid1.jpg", alt: "Avoid 1" },
  { src: "/Recomended photos/avoid2.jpg", alt: "Avoid 2" },
  { src: "/Recomended photos/avoid3.jpg", alt: "Avoid 3" },
];

const exampleImages = [
  { src: '/TryOnExamples/try1.png', alt: 'Example 1' },
  { src: '/TryOnExamples/try2.png', alt: 'Example 2' },
  { src: '/TryOnExamples/try3.png', alt: 'Example 3' },
];

const demoImages = [
  { src: '/Examples/original1.png', alt: 'Example 1' },
  { src: '/Examples/style1.png', alt: 'Example 2' },
  { src: '/Examples/result1.png', alt: 'Example 3' },
  { src: '/Examples/original2.png', alt: 'Example 1' },
  { src: '/Examples/style2.png', alt: 'Example 2' },
  { src: '/Examples/result2.png', alt: 'Example 3' },
];

const TryOn = () => {
  const [styleImageGender, setStyleImageGender] = useState(null)
  const [sourceImage, setSourceImage] = useState(null);
  const [selectedStyle, setSelectedStyle] = useState(null);
  const [colorImage, setColorImage] = useState(null);
  const [showCamera, setShowCamera] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [hairstyleLink, setHairstyleLink] = useState(null);
  const { getAuthHeaders, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const videoRef = useRef(null);
  const streamRef = useRef(null);

  const { user } = useAuth();


  const handleTryOn = (id, link) => {
    if (!user) {
      navigate('/login');
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/try-on', { state: { hairstyleId: id, hairstyleLink: link } });
  };

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', { 
        state: { from: location.pathname },
        replace: true 
      });
      return;
    }

    const loadHairstyleFromGallery = async () => {
      if (location.state?.hairstyleId) {
        try {
          const allHairstyles = [...menHairstyles, ...womenHairstyles, ...extentionsHairstyles, ...bangsHairstylesMen, ...bangsHairstylesWomen, ...volumeHairstylesWomen];
          const hairstyle = allHairstyles.find(h => h.id === location.state.hairstyleId);
          
          if(location.state?.hairstyleLink){
            setHairstyleLink(location.state.hairstyleLink)
          }

          if (hairstyle) {
            console.log('Loading hairstyle:', hairstyle); // Debug log
            const response = await fetch(hairstyle.image);
            if (!response.ok) {
              throw new Error('Failed to load hairstyle image');
            }
            const blob = await response.blob();
            setStyleImageGender(hairstyle.gender)
            const file = new File([blob], hairstyle.image.split('/').pop(), { type: 'image/png' });
            console.log('Created file:', file); // Debug log
            setSelectedStyle({ file, id: hairstyle.id });
          }
        } catch (err) {
          console.error('Error loading hairstyle:', err);
          setError('Failed to load selected hairstyle');
        }
      }
    };

    loadHairstyleFromGallery();

    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');
    if (sessionId) {
      verifyPayment(sessionId);
    }
  }, [isAuthenticated, navigate, location]);

  useEffect(() => {
    // Cleanup function to ensure camera is stopped when component unmounts
    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
      }
    };
  }, []);

  useEffect(() => {
    // Cleanup function
    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
      }
    };
  }, []);


 const wigsData = [
    {
      category: "Men Featured Wigs",
      items: [
        { name: "Blunt Bangs", src: "hairstyles/bangs-104/219691778809269123_Blunt Bangs.jpg", alt: "Original photo 1", link: "https://amzn.to/3EkfoEc" ,id: "219691778809269123" },
        { name: "Sleek Bangs", src: "hairstyles/bangs-104/219691778809269125_Sleek Bangs.jpg", alt: "Style photo 1", link: "https://amzn.to/3EkfoEc", id: "219691778809269125" },
        { name: "Mini Fringe", src: "hairstyles/bangs-104/219691778809269126_Mini Fringe.jpg", alt: "Result photo 1", link: "https://amzn.to/3EkfoEc", id: "219691778809269126" },
      ],
    },
    {
      category: "Women Featured Wigs",
      items: [
        { name: "Pixie", src: "hairstyles/women-hairstyle/Pixie.jpg", alt: "Original photo 2", link: "https://amzn.to/4gqDkTN", id: "6655" },
        { name: "Sleek Bangs", src: "hairstyles/bangs-103/200000000000001027_Sleek Bangs.jpg", alt: "Style photo 2", link: "https://amzn.to/3WQ7gBJ", id:"200000000000001027" },
        { name: "Long", src: "hairstyles/hairstyle_extension/206227835667350901_Length 3.jpg", alt: "Result photo 2", link: "https://amzn.to/4hLuG3c" , id:"206227835667350901"},
      ],
    },
  ];

  const startCamera = async () => {
    try {
      setShowCamera(true); // Set this first to ensure video element is rendered
      
      // Wait a bit for the video element to be available in the DOM
      await new Promise(resolve => setTimeout(resolve, 100));

      if (!videoRef.current) {
        throw new Error('Video element not initialized. Please try again.');
      }

      // Stop any existing streams
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
        streamRef.current = null;
      }

      console.log('Requesting camera...');
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: false
      });
      console.log('Camera access granted');

      // Double check video element still exists
      if (!videoRef.current) {
        throw new Error('Video element lost after camera access');
      }

      videoRef.current.srcObject = stream;
      streamRef.current = stream;

      // Wait for video to be ready
      await new Promise((resolve, reject) => {
        videoRef.current.onloadedmetadata = () => {
          videoRef.current.play()
            .then(resolve)
            .catch(reject);
        };
        videoRef.current.onerror = reject;
      });

      console.log('Video playback started');
      setError('');
    } catch (err) {
      console.error('Camera error:', err);
      setShowCamera(false);
      setError(`Camera error: ${err.message}. Please try again.`);
      
      // Cleanup on error
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
        streamRef.current = null;
      }
    }
  };

  const stopCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    setShowCamera(false);
  };

  const capturePhoto = () => {
    try {
      const video = videoRef.current;
      if (!video) {
        throw new Error('Video element not found');
      }

      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      
      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0);
      
      canvas.toBlob((blob) => {
        if (blob) {
          // Convert blob to File object with a unique name
          const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
          const file = new File([blob], `camera-photo-${timestamp}.jpg`, { 
            type: 'image/jpeg',
            lastModified: Date.now()
          });
          setSourceImage(file);
          stopCamera();
        } else {
          throw new Error('Failed to capture photo');
        }
      }, 'image/jpeg', 0.8);
    } catch (err) {
      console.error('Error capturing photo:', err);
      setError('Failed to capture photo. Please try again.');
    }
  };

  const handleImageUpload = (event, setImage) => {
    const file = event.target.files[0];
    if (file) {
      if (setImage === setSelectedStyle) {
        setSelectedStyle({ file, id: null });
      } else {
        setImage(file);
      }
      setError('');
    }
  };

  const generateImage = async () => {
    if (!sourceImage || !selectedStyle) {
      setError('Please select both a source image and a hairstyle.');
      return;
    }
    const genderGroupIdMap = {
      men: '10',
      female: '9',
      extension: '117112796700739619',
      'bangs-103': '103',
      'bangs-104': '104',
      volume: '117112796700739608'
    };

    setLoading(true);
    setError(null);

    try {
      const formData = new FormData();
      const groupId = genderGroupIdMap[styleImageGender];
      console.log(styleImageGender);
      formData.append('source', sourceImage);
      formData.append('style', selectedStyle.file);
      formData.append('style_id',selectedStyle.id)
      formData.append('style_group_id',groupId);

      if(hairstyleLink){
        formData.append('hairstyle_link', hairstyleLink);
      }

      if (colorImage) {
        formData.append('color', colorImage);
      }

      const response = await fetch(`${API_URL}/process_hair_style`, {
        method: 'POST',
        headers: {
          ...getAuthHeaders()
        },
        body: formData,
        credentials: 'include'
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to generate image');
      }

      const data = await response.json();
      
      if (data.success && data.session_url) {
        // Store session ID in localStorage for retrieval after payment
        localStorage.setItem('lastTryOnSession', data.session_id);
        // Redirect to Stripe Checkout
        // window.location.href = data.session_url;
        // window.open(data.session_url, '_blank');

        const popupWidth = 500;
        const popupHeight = 700;
        const left = (window.screen.width / 2) - (popupWidth / 2);
        const top = (window.screen.height / 2) - (popupHeight / 2);
        
       if (window.self !== window.top) {
            window.open(
                data.session_url, 
                'StripeCheckout', 
                `width=${popupWidth},height=${popupHeight},top=${top},left=${left}`
            );
        } else {
            window.location.href = data.session_url;
        }
        
      } else {
        throw new Error('No checkout URL received');
      }
    } catch (error) {
      console.error('Generation error:', error);
      setError(error.message || 'Failed to generate image. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const verifyPayment = async (sessionId) => {
    try {
      const response = await fetch(`${API_URL}/verify_payment/${sessionId}`, {
        headers: {
          ...getAuthHeaders()
        },
        credentials: 'include'
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Payment verification failed');
      }

      const data = await response.json();
      
      if (data.success) {
        window.location.href = `${API_URL}/view-image?session_id=${sessionId}`;
      } else {
        throw new Error('Payment verification failed');
      }
    } catch (error) {
      console.error('Payment verification error:', error);
      setError(error.message || 'Payment verification failed. Please contact support.');
    }
  };

  const handleCheckout = async (sessionId) => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/create-checkout-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          session_id: sessionId,
          success_url: `${window.location.origin}/success?session_id={CHECKOUT_SESSION_ID}`,
          cancel_url: `${window.location.origin}/try-on`
        }),
        credentials: 'include'
      });

      const data = await response.json();
      
      if (data.url) {
        // Store the session ID before redirecting
        localStorage.setItem('lastTryOnSessionId', sessionId);
        window.location.href = data.url;
      }
    } catch (error) {
      console.error('Error:', error);
      setError('Failed to process payment');
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="min-h-screen bg-gray-50 py-8"
    >
      {/* Header */}
      <div className="container mx-auto px-4 mb-8">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl font-bold text-gray-900">Virtual Hair Studio</h1>
          <button
            onClick={() => navigate(-1)}
            className="text-gray-600 hover:text-gray-800 transition-colors"
          >
            <FaArrowLeft className="text-xl" />
          </button>
        </div>
        <p className="text-gray-600 mt-2">Transform your look with our AI-powered hair styling tool</p>
      </div>

      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Column - Image Upload */}
          <div className="bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Upload Your Photos</h2>


            {/* Style Image Upload */}
            <div className="mb-6">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                {location.state?.hairstyleId ? "Selected Hairstyle" : "Style Reference"}
              </label>
              <div className="flex items-center justify-center w-full">
                {selectedStyle ? (
                  <div className="relative w-full">
                    <img
                      src={URL.createObjectURL(selectedStyle.file)}
                      alt="Style"
                      className="w-full h-64 object-cover rounded-lg shadow-md"
                    />
                    {!location.state?.hairstyleId && (
                      <button
                        onClick={() => setSelectedStyle(null)}
                        className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors"
                      >
                        <FaTimes className="w-4 h-4" />
                      </button>
                    )}
                  </div>
                ) : (
                  !location.state?.hairstyleId && (
                    <Link to="/studio-hair-salon" className="text-teal-500">
                    <label className="w-full flex flex-col items-center px-4 py-6 bg-white rounded-lg shadow-lg tracking-wide border-2 border-teal-500 border-dashed cursor-pointer hover:bg-teal-50 transition-colors">
                      <FaImages className="w-12 h-12 text-teal-500" />
                      <span className="mt-2 text-base text-gray-600">
                        Select Your Hairstyle From Gallery
                      </span>
                    </label>
                    </Link>
                  )
                )}
              </div>
            </div>
            
            {/* Source Image Upload */}
            <div className="mb-6">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Your Photo
              </label>
              <div className="flex items-center justify-center w-full">
                {sourceImage ? (
                  <div className="relative w-full">
                    <img
                      src={URL.createObjectURL(sourceImage)}
                      alt="Source"
                      className="w-full h-64 object-cover rounded-lg shadow-md"
                    />
                    <button
                      onClick={() => setSourceImage(null)}
                      className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors"
                    >
                      <FaTimes className="w-4 h-4" />
                    </button>
                  </div>
                ) : showCamera ? (
                  <div className="relative w-full">
                    <video
                      ref={videoRef}
                      autoPlay
                      playsInline
                      muted
                      style={{ transform: 'scaleX(-1)' }}
                      className="w-full h-64 object-cover rounded-lg shadow-md"
                    />
                    <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 space-x-4">
                      <button
                        onClick={capturePhoto}
                        className="bg-teal-500 text-white p-3 rounded-full hover:bg-teal-600 transition-colors shadow-lg"
                      >
                        <FaCamera className="w-5 h-5" />
                      </button>
                      <button
                        onClick={stopCamera}
                        className="bg-red-500 text-white p-3 rounded-full hover:bg-red-600 transition-colors shadow-lg"
                      >
                        <FaTimes className="w-5 h-5" />
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="w-full flex flex-col items-center">
                    <div className="flex gap-4 w-full">
                      <label className="flex-1 flex flex-col items-center px-4 py-6 bg-white rounded-lg shadow-lg tracking-wide border-2 border-teal-500 border-dashed cursor-pointer hover:bg-teal-50 transition-colors">
                        <FaUpload className="w-8 h-8 text-teal-500" />
                        <span className="mt-2 text-base text-gray-600">
                          Upload photo
                        </span>
                        <input
                          type="file"
                          className="hidden"
                          accept="image/*"
                          onChange={(e) => handleImageUpload(e, setSourceImage)}
                        />
                      </label>
                      <button
                        onClick={startCamera}
                        className="flex-1 flex flex-col items-center px-4 py-6 bg-white rounded-lg shadow-lg tracking-wide border-2 border-teal-500 border-dashed cursor-pointer hover:bg-teal-50 transition-colors"
                      >
                        <FaCamera className="w-8 h-8 text-teal-500" />
                        <span className="mt-2 text-base text-gray-600">
                          Use Camera
                        </span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>


            {/* Terms and Conditions Checkbox */}
            <div className="mt-6 flex items-start">
              <div className="flex items-center h-5">
                <input
                  id="terms"
                  name="terms"
                  type="checkbox"
                  checked={acceptedTerms}
                  onChange={(e) => setAcceptedTerms(e.target.checked)}
                  className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded cursor-pointer"
                />
              </div>
              <div className="ml-3 text-sm">
                <label htmlFor="terms" className="font-medium text-gray-700 cursor-pointer">
                  I accept the terms and conditions
                </label>
                <p className="text-gray-500">
                  By checking this box, you agree to our{' '}
                  <Link to="/legal/terms" className="text-teal-600 hover:text-teal-500">
                    Terms of Service
                  </Link>{' '}
                  and{' '}
                  <Link to="/legal/privacy" className="text-teal-600 hover:text-teal-500">
                    Privacy Policy
                  </Link>
                </p>
              </div>
            </div>

            {/* Generate Button */}
            <div className="mt-6">
              <button
                onClick={generateImage}
                disabled={!sourceImage || !selectedStyle || loading || !acceptedTerms}
                className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-xl shadow-sm text-sm font-medium text-white 
                  ${(!sourceImage || !selectedStyle || loading || !acceptedTerms)
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500'
                  }`}
              >
                {loading ? (
                  <>
                    <FaSpinner className="animate-spin -ml-1 mr-2 h-5 w-5" />
                    Generating...
                  </>
                ) : (
                  'Generate ($3.99)'
                )}
              </button>
            </div>

            {error && (
              <div className="mt-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg relative">
                <strong className="font-bold">Error:</strong>
                <span className="block sm:inline"> {error}</span>
              </div>
            )}
            
            {/* <h2 className="text-2xl font-bold text-gray-900 mb-6">Recommended Photos to Upload</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {exampleImages.map((image, index) => (
                  <div key={index} className="relative">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="rounded-lg shadow-sm w-full h-auto object-cover"
                    />
                  </div>
                ))}
              </div> */}


<div className="flex flex-col md:flex-row justify-between p-6 bg-white">
      {/* Recommendation Section */}
      <div className="w-full md:w-1/2 p-4">
        <h2 className="text-green-600 text-2xl font-bold">Recommendation</h2>
        <p className="text-gray-600 mt-2">
          Choose a photo where the face is clear and facing forward.
        </p>
        <div className="flex gap-4 mt-4">
          {recommendations.map((item, index) => (
            <div key={index} className="relative">
              <img
                src={item.src}
                alt={item.alt}
                className="w-20 h-20 rounded-lg border border-green-500"
              />
              <span className="absolute bottom-0 right-0 bg-green-500 text-white p-1 rounded-full text-sm">✔</span>
            </div>
          ))}
        </div>
      </div>

      {/* Avoid Section */}
      <div className="w-full md:w-1/2 p-4">
        <h2 className="text-red-600 text-2xl font-bold">Avoid</h2>
        <p className="text-gray-600 mt-2">
          Avoid photos of side face or hair covering shoulders.Ensure proper lighting.
        </p>
        <div className="flex gap-4 mt-4">
          {avoid.map((item, index) => (
            <div key={index} className="relative">
              <img
                src={item.src}
                alt={item.alt}
                className="w-20 h-20 rounded-lg border border-red-500"
              />
              <span className="absolute bottom-0 right-0 bg-red-500 text-white p-1 rounded-full text-sm">✘</span>
            </div>
          ))}
        </div>
      </div>
    </div>
              <div className="bg-gray-200 rounded-xl shadow-lg p-8">
              <a
                href="https://shareasale.com/r.cfm?b=2699812&u=2999377&m=101854&urllink=&afftrack="
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="wigs\wigs_ad.jpg"
                  alt="UniWigs - Premium Hair Toppers & Wigs, Your Perfect Hair Solution! Get 15% off your first order with code WELCOME15!"
                  style={{ border: "0" }}
                />
              </a>

              </div>

          </div>
        
          

          {/* Right Column - Preview and Instructions */}
          <div className="space-y-8">
            {/* Preview Section */}
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Preview</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {sourceImage && (
                  <div>
                    <h3 className="text-lg font-semibold mb-2">Your Photo</h3>
                    <img
                      src={URL.createObjectURL(sourceImage)}
                      alt="Source"
                      className="w-full h-48 object-cover rounded-lg shadow-md"
                    />
                  </div>
                )}
                {selectedStyle && (
                  <div>
                    <h3 className="text-lg font-semibold mb-2">Style Reference</h3>
                    <img
                      src={URL.createObjectURL(selectedStyle.file)}
                      alt="Style"
                      className="w-full h-48 object-cover rounded-lg shadow-md"
                    />
                  </div>
                )}
              </div>
            </div>

            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }} className="bg-white rounded-xl shadow-lg p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Trending Wigs & Extensions: 100% Human Hair</h2>
      <p className="text-gray-600 mb-4">Real Hair, Real You: Try on our luxury 100% human hair wigs for a realistic appearance. Find your shade and length. Claim your offer!</p>
      <div className="space-y-8">
        {wigsData.map((section, index) => (
          <motion.div
        key={index}
        className={index > 0 ? "pt-8" : ""}
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: index * 0.3 }}
      >
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          {section.category}
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {section.items.map((wig, idx) => (
            <div key={wig.id} className="group">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="relative overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <div className="aspect-w-3 aspect-h-4">
                  <img
                    src={wig.src}
                    alt={wig.alt}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-0 left-0 right-0 p-4">
                      <h3 className="text-white font-semibold text-lg">{wig.name}</h3>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Buttons moved outside motion div */}
              <div className="flex justify-center gap-3 mt-3">
                {/* Buy Now Button */}
                <a
                  href={wig.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-4 py-2 rounded-lg bg-yellow-400 text-black text-m font-medium shadow-md transition-all hover:bg-yellow-500 hover:shadow-lg"
                >
                  Buy
                </a>

                {/* Try Now Button */}
                <button
                  onClick={() => handleTryOn(wig.id, wig.link)}
                  className="px-4 py-2 rounded-lg bg-teal-400 text-white text-m font-medium shadow-md transition-all hover:bg-teal-500 hover:shadow-lg"
                >
                  Try
                </button>
              </div>
            </div>
          ))}
        </div>
      </motion.div>
    ))}
  </div>
</motion.div>
            {/* Instructions Section */}
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">How It Works</h2>
              <ol className="space-y-4">
                <li className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center text-teal-600 font-bold">
                    1
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Upload Your Photo</h3>
                    <p className="text-gray-600">Choose a clear, front-facing photo with good lighting</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center text-teal-600 font-bold">
                    2
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Select a Style</h3>
                    <p className="text-gray-600">Choose from our collection </p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center text-teal-600 font-bold">
                    3
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Generate</h3>
                    <p className="text-gray-600">Our AI will create your new look in seconds</p>
                  </div>
                </li>
              </ol>
            </div>

          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default TryOn;
